import { MapTo } from 'aem-vue-editable-components';
import {
    ForgotPassword,
    ForgotUsername,
    LoginTermsConditions,
    MemberLogin,
    MemberMfa,
    ResetPassword,
    LoginForm,
    PasswordInterrupt
} from './components';

import type { Plugin } from 'vue';

const memberLoginPlugin: Plugin = {
    install() {
        MapTo('commercial-web-my-health-toolkit/components/member-login')(
            MemberLogin
        );
        MapTo('commercial-web-my-health-toolkit/components/member-mfa')(
            MemberMfa
        );
        MapTo('commercial-web-my-health-toolkit/components/member-login-terms-conditions')(
            LoginTermsConditions
        );
        MapTo('commercial-web-my-health-toolkit/components/member-forgot-username')(
            ForgotUsername
        );
        MapTo('commercial-web-my-health-toolkit/components/member-retrieve-username')(
            LoginForm
        );
        MapTo('commercial-web-my-health-toolkit/components/member-forgot-password')(
            ForgotPassword
        );
        MapTo('commercial-web-my-health-toolkit/components/member-reset-password')(
            ResetPassword
        );
        MapTo('commercial-web-my-health-toolkit/components/member-password-interrupt')(
            PasswordInterrupt
        );
    }
};

export default memberLoginPlugin;
